import React from 'react';
import { Button, Spacer } from '@chakra-ui/react';
import { Context } from '../../App';
import Product from '../../model/product';
import Table, { TableProps } from '../../base-components/Table';
import EditorParent from '@/base-components/EditorParent';
import { ActiveBadge } from '../worksite/WorksitePage';
import { RoutePath, SPACING } from '@/generic/config';
import { useNavigate } from 'react-router-dom';

const ProductSearchPage = () => {
    const { translations, products } = React.useContext(Context);
    const navigate = useNavigate();

    const tableProps: TableProps<Product> = {
        columns: [
            { title: translations.model.product.id, scale: 1, getter: (r) => r.id },
            { title: translations.model.product.code, scale: 2, getter: (r) => r.code },
            { title: translations.common.active, scale: 1, getter: (r) => <ActiveBadge active={r.enabled} translations={translations} /> },
        ],
        rows: products?.data,
        isLoading: products?.isLoading,
        isRowDisabled: (row) => !row.enabled,
        href: (row) => `${RoutePath.Products}/${row.id}`,
    };

    return (
        <EditorParent title={translations.model.product.search.title}>
            <Button my={SPACING} onClick={() => navigate(`${RoutePath.Products}/new`)}>{translations.common.registerNew}</Button>
            <Table tableProps={tableProps} />
        </EditorParent>
    );
}

export default ProductSearchPage;
